export default __webpack_public_path__ + "static/media/EM0999.34I-41720_-25019_0.63fa46f4.jpg";